/* eslint-disable react/style-prop-object */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import formValueSelector from 'redux-form/es/formValueSelector';
import actions from 'redux-form/es/actions';
import { getOfferProductsAU, pushGaStepEvent } from 'actions/loan';
import { getOcmStatus } from 'actions/authentication';
import { fromCents, getCurrencyCode } from 'utils/helpers';
import LoadingPage from 'components/Credit24/LoanApplication/LoadingPage';
import OfferDetails from 'components/Credit24/LoanApplication/OfferDetailsAU';
import UpsellProduct from 'components/Credit24/LoanApplication/OfferDetailsAU/UpsellProduct';
import UpgradeProduct from 'components/Credit24/LoanApplication/OfferDetailsAU/UpgradeProduct';
import OcmProduct from 'components/Credit24/LoanApplication/OfferDetailsAU/OcmProduct';
import { injectIntl } from 'react-intl';

const { change } = actions;

const propTypes = {
  loan: PropTypes.object.isRequired,
  authentication: PropTypes.object.isRequired,
  getOfferProductsAU: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  principalIndex: PropTypes.number,
  firstDrawAmountIndex: PropTypes.number,
  selectedMaturity: PropTypes.number,
  creditLimit: PropTypes.string,
  getOcmStatus: PropTypes.func.isRequired,
  intl: PropTypes.object.isRequired,
};

class OfferDetailsAUContainer extends Component {
  UNSAFE_componentWillMount() {
    if (this.props.authentication.isAuthenticated) {
      this.props.getOfferProductsAU(this.props.loan.productType);

      if (this.props.loan.channel === 'OCM-WEB') {
        this.props.getOcmStatus();
      }
    }
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    this.props.pushGaStepEvent('loan_purpose');
  }

  componentDidUpdate(prevProps) {
    const {
      availablePrincipalsIndex,
    } = this.props.loan;

    if (!INCREASE_APP) {
      if (
        prevProps.authentication.isAuthenticated
                && prevProps.principalIndex !== this.props.principalIndex
                && this.props.loan.productType === 'INSTALLMENT'
      ) {
        const {
          availableProducts: prevAvailableProducts,
          availablePrincipalsIndex: prevAvailablePrincipalsIndex,
        } = prevProps.loan;
        const {
          availableProducts,
        } = this.props.loan;
        const prevProduct = (
          prevAvailableProducts[prevAvailablePrincipalsIndex[prevProps.principalIndex]]
        );
        if (prevProduct) {
          const prevFirstDrawAmount = (
            prevProduct.firstDrawAmountIndexes[prevProps.firstDrawAmountIndex]
          );
          const maxPrincipalIndex = availablePrincipalsIndex.length - 1;
          const productPrincipalIndex = Math.min(this.props.principalIndex, maxPrincipalIndex);
          const product = availableProducts[availablePrincipalsIndex[productPrincipalIndex]];
          const { firstDrawAmountIndexes } = product;
          const closestMaturityIfPrincipalWasChanged = firstDrawAmountIndexes
            .reduce((prev, curr) => {
              if (Math.abs(curr - prevFirstDrawAmount) < Math.abs(prev - prevFirstDrawAmount)) {
                return curr;
              }

              return prev;
            });
          const firstDrawIndex = firstDrawAmountIndexes
            .indexOf(closestMaturityIfPrincipalWasChanged);
          this.props.change('loan', 'firstDrawAmountIndex', firstDrawIndex);
        }
      }
    }
    if (prevProps.authentication.isAuthenticated && this.props.loan.productType === 'CREDIT_LINE'
            && availablePrincipalsIndex && availablePrincipalsIndex.length > 0
            && !this.props.principalIndex
    ) {
      this.props.change('loan', 'principalIndex', `${availablePrincipalsIndex.length - 1}`);
    }
  }

  render() {
    const {
      loan, principalIndex, firstDrawAmountIndex, creditLimit, intl,
    } = this.props;
    const {
      availablePrincipalsIndex = [], productType, isContentLoading, upsell, upgrade,
    } = loan;

    const loadingPage = (
      <div className="loan-form__step loan-form__step--loading">
        <LoadingPage />
      </div>
    );

    if (INCREASE_APP) {
      if (productType === 'INSTALLMENT') {
        if (isContentLoading || !upsell) {
          return loadingPage;
        }

        const { availablePrincipalsIndex: upsellPrincipalsIndex } = upsell;

        let selectedPrincipalsIndex = principalIndex;

        if (selectedPrincipalsIndex === undefined) {
          selectedPrincipalsIndex = upsellPrincipalsIndex.length - 1;
        }

        const selectedProduct = upsell.products[selectedPrincipalsIndex];

        const { availableMaturityPeriods } = selectedProduct;

        let selectedProductOffer = selectedProduct.productOffers[this.props.selectedMaturity];

        if (selectedProductOffer === undefined) {
          const largestMaturity = availableMaturityPeriods[availableMaturityPeriods.length - 1];

          selectedProductOffer = selectedProduct.productOffers[largestMaturity];
        }

        return (
          <UpsellProduct
            maximumAmount={upsell.maximumAmount}
            availablePrincipalsIndex={upsellPrincipalsIndex}
            maturityPeriods={availableMaturityPeriods}
            productOffer={selectedProductOffer}
            currentPayout={upsell.currentPayout}
            receivedAmount={selectedProduct.receivedAmount}
            paymentInterval={upsell.paymentInterval.toLowerCase()}
          />
        );
      }
      if (productType === 'CREDIT_LINE') {
        if (isContentLoading || !upgrade || !creditLimit) {
          return loadingPage;
        }
        const currency = getCurrencyCode();

        const creditLimits = upgrade.products.map((product) => {
          const limit = fromCents(product.creditAmount);
          return {
            type: product.creditAmount.toString(),
            title: intl.formatNumber(limit, {
              style: 'currency',
              currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }),
          };
        });

        const upgradeProduct = upgrade.products.find((product) =>
          product.creditAmount === creditLimit);

        const efectiveTerm = upgrade.products.find((product) =>
          product.creditAmount === creditLimit).totalBalanceRepaymentPeriodInMonths;

        return (
          <UpgradeProduct
            product={upgradeProduct}
            creditLimits={creditLimits}
            paymentInterval={upgrade.paymentInterval}
            efectiveTerm={efectiveTerm}
            productType={productType}
          />
        );
      }
    }
    if (isContentLoading || availablePrincipalsIndex.length === 0) {
      return loadingPage;
    }

    const currency = getCurrencyCode();

    const creditLimits = [...availablePrincipalsIndex]
      .map((principal, index) => {
        const limit = fromCents(principal);
        return {
          type: index.toString(),
          title: intl.formatNumber(limit, {
            style: 'currency',
            currency,
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }),
        };
      })
      .reverse();

    if (loan.channel === 'OCM-WEB') {
      return (
        <OcmProduct
          loan={loan}
          principalIndex={principalIndex}
          firstDrawAmountIndex={firstDrawAmountIndex}
          creditLimits={creditLimits}
        />
      );
    }

    return (
      <OfferDetails
        loan={loan}
        principalIndex={principalIndex}
        firstDrawAmountIndex={firstDrawAmountIndex}
        creditLimits={creditLimits}
      />
    );
  }
}

OfferDetailsAUContainer.propTypes = propTypes;

const selector = formValueSelector('loan');

export default connect(
  (state) => ({
    principalIndex: selector(state, 'principalIndex'),
    firstDrawAmountIndex: selector(state, 'firstDrawAmountIndex'),
    selectedMaturity: selector(state, 'selectedMaturity'),
    creditLimit: selector(state, 'creditLimit'),
  }),
  {
    getOfferProductsAU,
    getOcmStatus,
    change,
    pushGaStepEvent,
  }
)(injectIntl(OfferDetailsAUContainer));
